import { ReactNode } from "react"
import { Route } from "react-router-dom"
import { RouteProps, useRouteMatch, match } from "react-router"
import { Login } from "./login/Login"
import { useWistorAuth } from "../api/auth"


export function ProtectedRoute(props: {
  path: string,
  children?: ReactNode,
  protectIf?: (match: match<{}> | null) => boolean
} & RouteProps) {
  const auth = useWistorAuth()
  const { children, component, ...rest } = props
  const match = useRouteMatch(props.path)

  const shouldProtect = !props.protectIf || props.protectIf(match)
  const isAuthorized = shouldProtect ? auth.status === 'authorized' : true

  return (
    <Route
      {...rest}
      component={isAuthorized ? component : Login}
    />
  )
}
